
import React, { useEffect, useRef, useState } from "react";
import './Inteli.css';
import { signUp } from "../api/auth/authService";
import { useNavigate } from 'react-router-dom';
import Swal from "sweetalert2";
import { rsaService } from "../api/auth/rsaService";

export default function SignUp() {
  const inputRef = useRef(null);
  const navigate = useNavigate();

  const [userName, setUserName] = useState("");
  const [names, setNames] = useState("");
  const [password, setPassword] = useState("");

  const [nameError, setNameError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [passwordError, setPasswordError] = useState("");

  useEffect(() => {
    const scriptUrls = [
      "assets/js/jquery-3.7.1.min.js",
      "assets/js/bootstrap.bundle.min.js",
      "https://cdn.jsdelivr.net/npm/intl-tel-input@18.1.1/build/js/intlTelInput.min.js",
      "https://cdn.jsdelivr.net/npm/intl-tel-input@18.1.1/build/js/utils.js",
      "assets/js/script.js"
    ];

    let isCancelled = false;

    const loadScriptsSequentially = async () => {
      for (const url of scriptUrls) {
        if (isCancelled) break;

        await new Promise((resolve, reject) => {
          const script = document.createElement("script");
          script.src = url;
          script.async = false;
          script.onload = resolve;
          script.onerror = reject;
          document.body.appendChild(script);
        });
      }

      if (!isCancelled && window.intlTelInput) {
        window.intlTelInput(inputRef.current, {
          initialCountry: "in",
          utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@18.1.1/build/js/utils.js",
        });
      }
    };

    loadScriptsSequentially();

    return () => {
      isCancelled = true;
    };
  }, []);

  // Name validation
  const handleNameChange = (e) => {
    const value = e.target.value;

    if (/^[a-zA-Z\s]*$/.test(value)) {
      setNames(value);

      if (value.trim().length < 2) {
        setNameError("Name must be at least 2 characters");
      } else {
        setNameError("");
      }
    }
  };

  // Password validation
  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);

    if (value.length > 0 && (value.length < 8 || value.length > 10)) {
      setPasswordError("Password must be 8-10 characters long");
    } else {
      setPasswordError("");
    }
  };

  // Phone / Email validation
  const handleUserIdChange = (e) => {
    const value = e.target.value;
    setUserName(value);

    if (value.trim() === "") {
      setPhoneError("");
      return;
    }

    const isLocalPhone = /^[0-9]+$/.test(value);
    if (isLocalPhone) {
      if (value.length !== 10) {
        setPhoneError("Phone number must be exactly 10 digits");
      } else {
        setPhoneError("");
      }
    } else {
      const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      if (!isEmail) {
        setPhoneError("Enter valid email or 10-digit phone number");
      } else {
        setPhoneError("");
      }
    }
  };

  const [isSignup,setIsSignup] = useState(false);
  // Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSignup(true);
    let isValid = true;

    if (!names.trim() || !/^[a-zA-Z\s]{2,}$/.test(names)) {
      setNameError("Name must be at least 2 characters");
      isValid = false;
    } else {
      setNameError("");
    }

    const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userName);
    const isPhone = /^[0-9]{10}$/.test(userName);

    if (!userName.trim()) {
      setPhoneError("E-mail / Phone is required");
      isValid = false;
    } else if (!isEmail && !isPhone) {
      setPhoneError("Enter valid email or 10-digit phone number");
      isValid = false;
    } else {
      setPhoneError("");
    }

    if (!password) {
      setPasswordError("Password is required");
      isValid = false;
    } else if (password.length < 8 || password.length > 20) {
      setPasswordError("Password must be 8-20 characters long");
      isValid = false;
    } else {
      setPasswordError("");
    }

    if (!isValid){
      setIsSignup(false);
      return;
    } 

    try {
      const encrypted = await rsaService.encrypt(password);

      const formData = {
        name: names,
        userId: userName,
        password: encrypted.cipherText,
        rasId: encrypted.keyId
      };

      const response = await signUp(formData);
      const res = response.data;

      if (res.statusCode === "OK") {
        Swal.fire({
          title: 'Success!',
          text: res.data,
          icon: 'success',
          confirmButtonColor: '#566fe2'
        }).then(() => {
          navigate('/login');
        });

      } else {
        Swal.fire({
          title: 'Error!',
          text: res.data,
          icon: 'error',
          confirmButtonColor: '#d33'
        });
      }

    } catch (error) {
      console.log(error);
      Swal.fire("Error", "Something went wrong", "error");
    }finally {
      setIsSignup(false);
    }
  };

  return (
    <div>
      <div className="content">
        <div className="container-fluid">
          <div className="row mt-4">
            <div className="col-md-8 offset-md-2">
              <div className="account-content" style={{ marginTop: "20px", border: "1px solid #9f9b9b", padding: "30px", borderRadius: "8px", boxShadow: "0 3px 8px rgba(0,0,0,0.24)" }}>
                <div className="row align-items-center justify-content-center">

                  <div className="col-md-7 col-lg-6 login-left">
                    <img src="assets/img/login-banner.png" className="img-fluid" alt="Webnet Login" />
                  </div>

                  <div className="col-md-12 col-lg-6 login-right">
                    <div className="login-header">
                      <h3>Patient Register</h3>
                    </div>

                    <form onSubmit={handleSubmit}>

                      {/* Name */}
                      <div className="mb-3">
                        <label className="form-label">Name</label>
                        <input
                          type="text"
                          className="form-control"
                          value={names}
                          onChange={handleNameChange}
                        />
                        {nameError && <small className="text-danger">{nameError}</small>}
                      </div>

                      {/* Email / Phone */}
                      <div className="mb-3">
                        <label className="form-label">E-mail / Phone</label>
                        <input
                          ref={inputRef}
                          className="form-control form-control-lg group_formcontrol form-control-phone"
                          type="text"
                          value={userName}
                          onChange={handleUserIdChange}
                          placeholder="Email or Phone Number"
                        />
                        {phoneError && <small className="text-danger">{phoneError}</small>}
                      </div>

                      {/* Password */}
                      <div className="mb-3">
                        <div className="form-group-flex">
                          <label className="form-label">Create Password</label>
                        </div>
                        <div className="pass-group">
                          <input
                            type="password"
                            className="form-control pass-input"
                            value={password}
                            onChange={handlePasswordChange}
                          />
                          <span className="feather-eye-off toggle-password" />
                        </div>
                        {passwordError && <small className="text-danger">{passwordError}</small>}
                      </div>

                      {/* Submit */}
                      <div className="mb-3">
                        <button className="btn btn-primary-gradient w-100" type="submit" disabled={isSignup}>
                          {(isSignup)?"Loading ...":"Sign Up"}
                        </button>
                      </div>

                      <div className="account-signup">
                        <p>
                          Already have account?{" "}
                          <a href="/login" className="btn btn-md btn-primary-gradient d-inline-flex align-items-center rounded-pill">
                            Sign In
                          </a>
                        </p>
                      </div>

                    </form>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
